import * as React from "react";
import AccordionGroup from "@mui/joy/AccordionGroup";
import Accordion from "@mui/joy/Accordion";
import AccordionDetails from "@mui/joy/AccordionDetails";
import AccordionSummary from "@mui/joy/AccordionSummary";
import ListItem from "@mui/joy/ListItem";
import ListItemButton from "@mui/joy/ListItemButton";
import List from "@mui/joy/List";
import { domain } from "../../data";
import { useNavigate } from "react-router-dom";

export default function InnerMenuAccordion() {
	// const { setOpen } = props;
	const [expanded, setExpanded] = React.useState(null);
	const navigate = useNavigate();

	const accordionItems = [
		{
			title: "About account",
			items: [
				"About Personal Account",
				"Beneficiaries & their testament",
				"Buy BTC",
				"Buy ETH",
				"Buy USDT",
			],
			url: "/en/register",
		},
		{
			title: "Platforms",
			items: [
				`${domain} MT5`,
				`${domain} cTrader`,
				`${domain} X`,
				`${domain} Trader`,
				`${domain} Bot`,
				`${domain} Go`,
				`SmartTrader`,
			],
			url: "/en/register",
		},

		{
			title: "Markets",
			items: [
				"Forex",
				"Derived Indices",
				"Stocks",
				"Stock Indices",
				"Commodities",
				"Cryptocurrencies",
				"ETFs",
			],
			url: "/en/register",
		},
		{
			title: "Trade",
			items: ["CFDs", "Options"],
			url: "/en/register",
		},
		// {
		// 	title: "Tools",
		// 	items: [
		// 		"Trading View",
		// 		"MT5 Signals",
		// 		"Trading Calculator",
		// 		"Trading Central",
		// 		"Economic Calendar",
		// 		"Market Buzz",
		// 	],
		// 	url: "/en/login",
		// },
		{
			title: "About Us",
			items: [
				"Who we are",
				"Why choose us",
				"Regulatory information",
				"Secure & responsible trading",
				"Careers",
				"Newsroom",
			],
			url: "/about",
		},
		{
			title: "Service",
			items: [
				"Secure & Reliable Trading Platform",
				"Real-time Market Data & Insights",
				"Advanced Trading Tools",
				"Educational Resources & Support",
			],
			url: "/service",
		},
		{
			title: "News & Analysis",
			items: ["Explore"],
			url: "/news",
		},

		// {
		// 	title: "Support and Help Center",
		// 	items: ["Explore"],
		// 	url: "/support",
		// },
	];

	const handleAccordionChange = (panel) => (event, isExpanded) => {
		setExpanded(isExpanded ? panel : null);
	};

	const naviagator = (path) => {
		// setOpen(false);
		navigate(path);
	};
	return (
		<AccordionGroup sx={{ maxWidth: 400 }}>
			{accordionItems.map((accordion, index) => (
				<Accordion
					key={accordion.title}
					expanded={expanded === accordion.title}
					onChange={handleAccordionChange(accordion.title)}>
					<AccordionSummary>{accordion.title}</AccordionSummary>
					<AccordionDetails>
						<List>
							{accordion.items.map((item, itemIndex) => (
								<ListItem key={`${accordion.title}-${itemIndex}`}>
									<ListItemButton
										onClick={() => {
											naviagator(accordion.url);
										}}>
										- {item}
									</ListItemButton>
								</ListItem>
							))}
						</List>
					</AccordionDetails>
				</Accordion>
			))}
		</AccordionGroup>
	);
}
